import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import OurFoundation from "./sections/OurFoundation";
import SolutionsOverview from "./sections/SolutionsOverview";
import DigitalAssetsOverview from "./sections/DigitalAssetsOverview";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <OurFoundation />
      <SolutionsOverview />
      <DigitalAssetsOverview />
      <Footer />
    </div>;
}